/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
export const QuizData = [
  {
    id: 1,
    question: `Which of the following attribute is used to provide a unique name to an element?`,
    options: [`class`, `id`, `type`, `None of the above`],
    answer: `id`,
  },
  {
    id: 2,
    question: `Which HTML tag is used to display the power in expression, i.e., (x2 - y2)?`,
    options: [`<sup>`, `<sub>`, `<p>`, `None of the above`],
    answer: `<sup>`,
  },
  {
    id: 3,
    question: `If we want to wrap a block of text around an image, which css property will we use ?`,
    options: [`wrap`, `push`, `float`, `align`],
    answer: `float`,
  },
  {
    id: 4,
    question: `The <hr> tag in HTML is used for -`,
    options: [`new line`, `vertical ruler`, `new paragraph`, `horizontal ruler`],
    answer: `horizontal ruler`,
  },
  {
    id: 5,
    question: `Can we align a Block element by setting the left and right margins ?`,
    options: [`Yes, we can`, `Not Possible`],
    answer: `Not Possible`,
  },
  {
    id: 6,
    question: `Suppose we want to arragnge five nos. of DIVs so that DIV4 is placed above DIV1. Now, which css property will we use to control the order of stack?`,
    options: [`d-index`, `s-index`, `x-index`, `z-index`],
    answer: `z-index`,
  },
  {
    id: 7,
    question: `What should be the table width, so that the width of a table adjust to the current width of the browser window?`,
    options: [`640 pixels`, `100%`, `full-screen`, `1024 px`],
    answer: `100%`,
  },
  {
    id: 8,
    question: `How will you make all paragraph elements 'RED' in color ?`,
    options: [
      `p.all {color: red;}`,
      `p.all {color: #990000;}`,
      `all.p {color: #998877;}`,
      `p {color: red;}`,
    ],
    answer: `p {color: red;}`,
  },
  {
    id: 9,
    question: `How can we write comment along with CSS code ?`,
    options: [`/* a comment */`, `// a comment //`, `/ a comment /`, `<' a comment'>`],
    answer: `/* a comment */`,
  },
  {
    id: 10,
    question: `The default value of "position" attribute is _________.`,
    options: [`fixed`, `absolute`, `inherit`, `relative`],
    answer: `relative`,
  },
  {
    id: 11,
    question: `By default Hyperlinks are displayed with an underline. How do you remove the underline from all hyperlinks by using CSS code ?`,
    options: [
      `a {text: no-underline;}`,
      `a {text-decoration:none;}`,
      `a {text-style: no-underline;}`,
      `a {text-decoration: no-underline;}`,
    ],
    answer: `a {text: no-underline;}`,
  },
  {
    id: 12,
    question: `Which type of JavaScript language is ___`,
    options: [`Object-Oriented`, `Object-Based`, `Assembly-language`, `High-level`],
    answer: `Object-Based`,
  },
  {
    id: 13,
    question: `varx=5,y=1  
    var obj ={ x:10}  
    with(obj)  
    {  
          alert(y)  
    } `,
    options: [`1`, `Error`, `10`, `5`],
    answer: `1`,
  },
  {
    id: 14,
    question: `In JavaScript, what is a block of statement?`,
    options: [
      `Conditional block`,
      `block that combines a number of statements into a single compound statement`,
      `both conditional block and a single statement`,
      `block that contains a single statement`,
    ],
    answer: `block that combines a number of statements into a single compound statement`,
  },
  {
    id: 15,
    question: `Which one of the following is the correct way for calling the JavaScript code?`,
    options: [`Preprocessor`, `Triggering Event`, `RMI`, `Function/Method`],
    answer: `Function/Method`,
  },
  {
    id: 16,
    question: `Which of the following type of a variable is volatile?`,
    options: [`Mutable variable`, `Dynamic variable`, `Volatile variable`, `Immutable variable`],
    answer: `Mutable variable`,
  },
  {
    id: 17,
    question: `var  obj=  
    {  
        length:20,  
        height:35,  
    }  
    if('breadth' in obj === false)   
    {  
        obj.breadth = 12;  
    }  
       
    console.log(obj.breadth); `,
    options: [`Error`, `Undefined`, `12`, `20`],
    answer: `12`,
  },
  {
    id: 18,
    question: `var count =0;  
    while (count <10)  
    {  
         console.log(count);  
         count++;  
    }  `,
    options: [
      `An error is displayed`,
      `An exception is thrown`,
      `The values of count variable are logged or stored in a particular location or storage`,
      `The value of count from 0 to 9 is displayed in the console`,
    ],
    answer: `The values of count variable are logged or stored in a particular location or storage`,
  },
  {
    id: 19,
    question: `Int x=8;  
    if(x>9)  
    {  
    document.write(9);  
    }  
    else  
    {  
    document.write(x);  
    }  `,
    options: [`9`, `0`, `8`, `Undefined`],
    answer: `8`,
  },
  {
    id: 20,
    question: `Which of the following number object function returns the value of the number?`,
    options: [`toString()`, `valueOf()`, `toLocaleString()`, `toPrecision()`],
    answer: `valueOf()`,
  },
];
